/**
 * pdfTheme.js — Sistema de diseño para PDFs
 * Principio: header ultra-compacto, logo única identidad, info derecha.
 */
import { cabecera } from './pdf/v2/base.js';
import { ctxDe, dibujarFooter } from './pdf/layout.js';

// ── Paleta ────────────────────────────────────────────────────────────────────
export const DARK       = [20,  18,  16 ];
export const RED        = [209, 58,  40 ];
export const GOLD       = [212, 136, 0  ];
export const WHITE      = [255, 255, 255];
export const GRAY_LIGHT = [245, 244, 242];
export const GRAY_MID   = [200, 196, 190];
export const GRAY_TEXT  = [120, 116, 110];
export const WARM_BORDER= [220, 212, 200];

// ── Datos empresa — se toman del perfil del usuario logueado ─────────────────
function getUsuario() {
    try { return JSON.parse(localStorage.getItem('auth_usuario') || '{}'); } catch { return {}; }
}
export function getEmpresa() {
    const u = getUsuario();
    return {
        contacto:  u.whatsapp || u.telefono || '',
        email:     'info@dispenserlatienda.com.ar',
        web:       'dispenserlatienda.com.ar',
        redes:     '@dispenserlatienda',
        tiktok:    '@dispenserlatienda',
    };
}

// ── Fecha ─────────────────────────────────────────────────────────────────────
export function procesarFecha(f) {
    try {
        if (!f) return new Date().toLocaleDateString('es-AR');
        const d = new Date(f.includes('T') ? f : `${f}T12:00:00`);
        return isNaN(d.getTime()) ? new Date().toLocaleDateString('es-AR') : d.toLocaleDateString('es-AR');
    } catch { return new Date().toLocaleDateString('es-AR'); }
}

// ── Header (todos los documentos) ─────────────────────────────────────────────
// Esquema:
//   [LOGO]               [Fecha: DD/MM/AAAA         ]
//   [Tel · WA]           [PP-DDMM-XX-01  (rojo bold) ]
//   [dirección]          [Téc: Nombre     (gris)      ]
//   ──────────────────────────────────────────────────
//   TÍTULO DEL DOCUMENTO (10pt, izquierda)
//
// Altura total del header normal  ≈ 46mm  → contenido empieza en y=46
// Altura total del header compacto ≈ 37mm → contenido empieza en y=37
export function dibujarHeaderPDF(doc, tipoLabel, fecha, subtitulo = null, nroDoc = null) {
    // 18-oct-2026: misma cabecera que el resto de los PDF
    return cabecera(doc, ctxDe({ tipoLabel, fecha, nroDoc, extra: subtitulo }));
}

// ── Footer ────────────────────────────────────────────────────────────────────
// Estructura (2 filas):
//   ────────────────────── línea separadora ──────────────────────
//   [leyenda/garantía centrada]
//   [Tel · WA  (izq)]                            [pág/total (der)]
//   ██████████████████████ banda roja ███████████████████████████
export function dibujarFooterPDF(doc, pagina = null, totalPaginas = null, textoCentral = null) {
    // 18-oct-2026: mismo pie que el resto de los PDF (contacto de la empresa con WhatsApp)
    return dibujarFooter(doc, { pagina, totalPaginas, textoCentral });
}

